import React, { Fragment, useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import AdminLayout from "../layouts/AdminLayout";
import CustomerLayout from "../layouts/CustomerLayout";
import ChatLayouts from "src/layouts/ChatLayouts";
import WebsiteLayout from "src/layouts/WebsiteLayout";

import {
  ICustomJwtPayload,
  getToken,
  removeToken,
} from "../helpers/helperFunctions";

import { removeAuth, setAuth, setUserDetails } from "../Store/reducer";
import SplashScreen from "../Components/SplashScreen";
import { jwtDecode } from "jwt-decode";
import { IRouteItem } from "src/types/routeTypes";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { AppDispatch, RootState } from "@store/store";
import { doctor, operator, superAdmin } from "src/lib/constans";
import { setDoctorState } from "../Store/doctor";
import { getIndicators } from "src/Store/redDots";
import { removeAllIndicators } from "src/Store/redDots";
import { clearCart, setCurrentAddress } from "src/Store/cartSlice";
import { setCartItems } from "@store/Cart";

// Define props for ProtectedRoute component
interface IProtectedRouteProps {
  item: IRouteItem;
}

const layouts: Record<string, React.FC<any> | typeof Fragment> = {
  admin: AdminLayout,
  customer: CustomerLayout,
  chat: ChatLayouts,
  website: WebsiteLayout,
  none: Fragment,
};

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ item }) => {
  const { layout, role, ele, isProtected, fallBack , path } = item;
  const [isLoading, setIsLoading] = useState<boolean | undefined>(isProtected);
  const [unauthorize, setUnauthorize] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const { isLogged } = useSelector((state: RootState) => state.appReducer);
  const navigate = useNavigate();
  const LayoutComponent = layouts[layout];

  const token = getToken();

  const navigateToFallBack = () => {
    navigate(fallBack || "/");
  };

  useEffect(() => {
    if (isLogged && token) {
      const decodedToken = jwtDecode<ICustomJwtPayload>(token);

      const userRole = decodedToken?.userRole || "";
      if (!(role || []).includes(userRole as string) && isProtected) {
        setTimeout(() => {
          setUnauthorize(true);
        }, 0);
      } else {
        setUnauthorize(false);
      }
      setIsLoading(false);
    }
  }, [navigate, isLogged, token]);

  useEffect(() => {
    if (!isLogged && !isLoading && isProtected) {
      navigateToFallBack();
    }
  }, [isLogged, isLoading, isProtected, navigate, fallBack]);

  useEffect(() => {
    async function init() {
      if (isLoading) {
        if (token) {
          const decodedToken = jwtDecode<ICustomJwtPayload>(token);
          const userRole = decodedToken?.userRole || "";

          const { res, err } = await httpRequest<any>({
            path:
              userRole === operator || userRole === superAdmin
                ? "/operators/profile"
                : userRole === doctor
                ? `/doctors/profile/${decodedToken?.id}`
                : "/customer/profile",
          });
          console.log("REsponse from profile", res);
          if (res) {
            if(res?.accountActive === false){
              toast("Your account is Deactivated", { type: "info" });
              dispatch(removeAllIndicators());
              removeToken();
              navigate("/doctor/login");
              dispatch(removeAuth());
              return;
            }
            if (res?.userRole === doctor) {
              dispatch(setDoctorState(res?._id));
            }
            dispatch(setAuth(token));
            dispatch(setUserDetails(res));
            
            if (res?.userRole === superAdmin || res?.userRole === operator) {
              // dispatch(getIndicators("/operators/admin-indicators"));
            } else {
              // add customer red dots api only change endpoints
            }
          } else {
            toast(err, { type: "error" });
            dispatch(removeAuth());
            dispatch(removeAllIndicators());
            removeToken();
            navigateToFallBack();
          }
        } else {
          navigateToFallBack();
        }
        setIsLoading(false);
      }
    }
    init();
  }, [isProtected, token]);

  if (unauthorize) {
    return <Unauthorize />;
  }

  if (isLoading) {
    return <SplashScreen />;
  }

  return <LayoutComponent>{ele}</LayoutComponent>;
};

export default ProtectedRoute;

const Unauthorize: React.FC = () => {
  return (
    <div
      className="bg-secondary bg-opacity-25 d-flex align-items-center justify-content-center w-100"
      style={{ height: "100vh" }}
    >
      <p className="text-secondary mb-0">
        You are not authorize to access this route. Go to{" "}
        <Link to="/" className="text_slate text-decoration-underline">
          Home
        </Link>
      </p>
    </div>
  );
};
